module.exports = __webpack_public_path__ + "static/media/free-drainage.b40ed63e.jpg";